module.exports = __webpack_public_path__ + "static/media/banner2768.133e328d.jpg";